export default {
  BEGIN_CLAIMS: 'BEGIN_CLAIMS',
  SET_CLAIMS: 'SET_CLAIMS',
  OPEN_CLAIM_DETAILS: 'OPEN_CLAIM_DETAILS',
  CLOSE_CLAIM_DETAILS: 'CLOSE_CLAIM_DETAILS',
  SET_CLAIMS_ERROR: 'SET_CLAIMS_ERROR'
};
